const startYear = 1970;
const currentYear = new Date().getFullYear();

const gradYearsArray = Array.from(
  { length: currentYear - startYear + 1 },
  (_, i) => startYear + i
).reverse();

export default gradYearsArray;
